// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2OYMa","imageUploader":"EGiftCard_imageUploader__3Iys4"};